<template>
    <v-container fluid class="mr-10">
        <v-row>
            <v-col class="d-flex" cols="12" sm="6">
                <p class="text-h3">Fichas</p>
            </v-col>
		</v-row>
        <v-row>  
            <v-col class="d-flex">
                <v-expansion-panels flat accordion v-model="panel">
                    <v-expansion-panel>
                        <v-expansion-panel-header hide-actions>
                            <v-btn tile outlined max-width="120">
                                <v-icon left>mdi-chart-gantt</v-icon>{{$t('message.filters')}}
                            </v-btn>
                            <v-btn link tile outlined max-width="120" @click.native.stop @click="clear" v-if="showClear">
                                Limpar
                            </v-btn>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content >
                            <v-text-field
                                v-model="searchName"
                                label="Nome"
                                placeholder="Digite um nome de ficha"
                                outlined
                                clearable
                            >
                            </v-text-field>
                             <v-select
                                :items="contexts"
                                item-text="name"
                                :label="$t('message.contexts')"
                                outlined
                                multiple
                                :hint="$t('message.contexts_select_hint')"
                                :menu-props="{offsetY: true}"
                                persistent-hint
                                v-model="selectedContexts"
                                return-object
                            ></v-select>
                            <v-select
                                :items="avaiableSections"
                                item-text="name"
                                :label="$t('message.sections')"
                                outlined
                                multiple
                                :hint="$t('message.sections_select_hint')"
                                :menu-props="{offsetY: true}"
                                persistent-hint
                                v-model="selectedSections"
                                return-object
                            ></v-select>
                        </v-expansion-panel-content>
                    </v-expansion-panel>        	
                </v-expansion-panels>			
			</v-col>
		</v-row>
        <v-divider></v-divider>
        <v-container>
            <p class="subtitle-1">Exibindo {{filteredCardsLenght}} ficha(s)</p>
            <v-row align="start">            
                <preview v-for="card in filteredCards" v-bind:item="card" v-bind:key="card.id" :preview="card"></preview>
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
    import API from "../services/Api";
    import parser from  "../utils/parser";
    import Utils from '../utils/utils';
    import Preview from '../components/Preview';
	export default {
		data: () => ({
            cards: [],
            contexts: [],
            sections: [],
            selectedContexts: [],
            selectedSections: [],
            searchName: "",
            panel: 1
        }),
        methods: { 
            clear(){
                this.searchName = "";
                this.selectedContexts = [];
                this.selectedSections = [];
            }
        },
        beforeMount(){
            this.searchName = this.$store.getters.cardsFilters.text;
            this.selectedContexts = this.$store.getters.cardsFilters.contexts;
            this.selectedSections = this.$store.getters.cardsFilters.sections;
            if(this.searchName != '' || this.selectedContexts.length > 0 || this.selectedSections.length > 0){
                this.panel = 0;
            }
        },
        mounted(){
            var token = this.$store.state.auth.token;
            API.getMyCards(token)
                .then(response=>{
                    this.cards = parser.getMyCardsToCards(response);
                    this.cards.forEach(card=>{
                        if(!Utils.containsSection(this.sections, card.section)){
                            this.sections.push(card.section);
                        }
                        if(!Utils.containsContext(this.contexts, card.section.context)){
                            this.contexts.push(card.section.context);
                        }                        
                    });                    
                })
                .catch(err=>{
                    console.log(err);
                })  
        },
        computed:{ 
            showClear(){
                if(this.searchName != '' || this.selectedContexts.length > 0 || this.selectedSections.length > 0){
                    return true;
                }
                return false;
            },
            avaiableSections(){
                if(this.selectedContexts.length==0){
                    return this.sections;
                }else{
                    var filtered = [];
                    this.sections.forEach(section=>{
                        this.selectedContexts.forEach(context=>{
                            if(section.context.id == context.id){
                                filtered.push(section);
                            }
                        })                        
                    })
                    return filtered;
                }
            },
            filteredCardsLenght(){
                return this.filteredCards.length;
            },
            filteredCards(){
                var sectionFiltered = [];                
                if(this.selectedSections.length == 0 && this.selectedContexts.length==0){
                    sectionFiltered = this.cards;
                }else{             
                    if(this.selectedSections.length == 0){
                        this.cards.forEach((card)=>{                        
                            this.selectedContexts.forEach(context=>{
                                if(card.section.context.id == context.id){
                                    if(!Utils.containsCard(sectionFiltered, card)){
                                        sectionFiltered.push(card);
                                    }
                                }
                            });
                        });
                    }else{
                        this.cards.forEach((card)=>{    
                            this.selectedSections.forEach((section)=>{
                                if(card.section.id == section.id){
                                    if(!Utils.containsCard(sectionFiltered, card)){
                                        sectionFiltered.push(card);
                                    }
                                }
                            });
                        });
                    }                          
                }               
                var filtered = [];
                if(this.searchName != ""){
                    filtered = sectionFiltered.filter((card)=>{
                        return this.searchName.toLowerCase().split(' ').every(v => card.translations[0].title.toLowerCase().includes(v));
                    });                    
                }else{
                    filtered = sectionFiltered
                }
                this.$store.dispatch("UPDATE_CARDS_TEXT", this.searchName);
                this.$store.dispatch("UPDATE_CARDS_SELECTS", {sections: this.selectedSections, contexts:this.selectedContexts});
                return filtered;
            }
        },
        components: {
            'preview': Preview
        }
	};
</script>